<template>
    <div class="d-flex justify-content-center align-items-center flex-grow-1" ref="canvasWindow">
        <div class="position-relative overflow-hidden" id="canvas-wrapper">
            <canvas id="c" ref="canvas" height="700" class="canvas-filter"></canvas>

            <div v-if="Object.keys(store.warnings).length > 0" class="position-absolute inset-0 d-flex justify-content-center align-items-start p-0 p-sm-4 pe-none">
                <div class="slide-in-from-top position-relative">
                    <div class="alert alert-warning shadow text-center m-0">
                        {{ store.warnings[Object.keys(store.warnings)[0]] }}
                    </div>
                </div>
            </div>

            <!--Loading spinner (bottom right of canvas)-->
            <div v-if="store.processing" class="position-absolute inset-0 d-flex justify-content-start align-items-start justify-content-md-end align-items-md-end pe-none p-4">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>

            <image-editor-floating-buttons></image-editor-floating-buttons>
        </div>
    </div>
</template>

<script>
import { fabric } from 'fabric';
import { useImageEditorStore } from './store';

import "./js/changeHistory";
import "./js/save&Load";
import { ImageEditor } from "./imageEditor";
import ImageEditorFloatingButtons from "./ImageEditorFloatingButtons";
import CurvedText from "./js/textService/CurvedText";
import PdfObject from "./js/objects/pdfObject";

export default {
    components: {ImageEditorFloatingButtons},
    setup() {
        const store = useImageEditorStore();

        return {
            store: store,
            imageEditor: null,
        }
    },
    mounted() {
        this.initCanvas();
    },
    methods: {
        initCanvas() {
            this.store.canvas = new fabric.Canvas('c', {
                preserveObjectStacking: true,
                controlsAboveOverlay: true,
                originX: 'center',
                originY: 'center',
            });
            this.imageEditor = new ImageEditor({store: this.store, canvasWindow: this.$refs.canvasWindow});

            if (window.FleetCart.imageData) {
                setTimeout(()=> {
                    window.imageEditor.load(window.FleetCart.imageData, ()=> {
                        this.imageEditor.saveState('initial');
                    });
                }, 0);
            } else {
                this.imageEditor.saveState('initial');
            }
        },
    }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Barriecito&family=Comic+Neue&family=Days+One&family=Fontdiner+Swanky&family=Gluten&family=Indie+Flower&family=Inter:wght@100;200;300;400;500;600;700;800&family=Permanent+Marker&family=Press+Start+2P&family=Quicksand&family=Qwitcher+Grypen:wght@700&family=Roboto&family=Rubik+Moonrocks&family=Sedgwick+Ave+Display&family=Special+Elite&family=Baloo+Bhai+2:wght@500&family=League+Gothic&family=League+Spartan:wght@500&family=Mukta:wght@500&family=Open+Sans:wght@500&display=swap');

.canvas-filter {
    filter: drop-shadow(#00000042 4px 4px 4px);
}
</style>
